<template>
  <div>
    <top-bar title="Donation"/>
    <container class="donation-page">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <h2>คุณสมบัติเบื้องต้นของว่าที่ฮีโร่</h2>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row donation-qualification">
          <div class="col-3 img-container">
            <img class="dog-img" src="@/assets/other/dog-outline-partial.png" alt="">
          </div>
          <div class="col-9">
            <table>
              <tr v-for="quali in dogQualifications" :key="quali">
                <td><img src="@/assets/icon/check.png" alt="check icon"></td>
                <td>{{ quali }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row donation-qualification">
          <div class="col-3 img-container">
            <img class="cat-img" src="@/assets/other/cat-outline-partial.png" alt="">
          </div>
          <div class="col-9">
            <table>
              <tr v-for="quali in catQualifications" :key="quali">
                <td><img src="@/assets/icon/check.png" alt="check icon"></td>
                <td>{{ quali }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </container>
    <donation-prep-section/>
    <donation-step-section/>
    <blood-collection-section/>
    <donation-after-section/>
    <donation-thank-you-section/>
    <container class="donation-page">
      <div class="col-12">
        <h2>โรงพยาบาลสัตว์ในเครือข่าย<br/>ที่สามารถนำสัตว์เลี้ยงไปบริจาคเลือดได้</h2>
        <p class="subtitle">
          ถ้าคุณพร้อมที่จะพาเจ้าสี่ขาของคุณไปเป็นฮีโร่แล้ว สามารถตรวจสอบสถานที่บริจาคเลือด
          ได้จากเครือข่ายด้านล่างนี้เลย
        </p>
      </div>
      <hospital-card class="h-card" v-for="hospital in hospitalList" :key="hospital.name"
        :showBloodBag="false"
        :hospital="hospital"/>
    </container>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import Container from '@/components/Container.vue'
import HospitalCard from '@/components/HospitalCard.vue'
import DonationPrepSection from '@/components/donation/DonationPrepSection.vue'
import DonationStepSection from '@/components/donation/DonationStepSection.vue'
import BloodCollectionSection from '@/components/donation/BloodCollectionSection.vue'
import DonationAfterSection from '@/components/donation/DonationAfterSection.vue'
import DonationThankYouSection from '@/components/donation/DonationThankYouSection.vue'

export default {
  name: 'Donation',
  data () {
    return {
      dogQualifications: [
        'อายุ 1-7ปี',
        'น้ำหนัก 17kg. ขึ้นไป',
        'สุขภาพแข็งแรง ไม่มีโรคประจำตัว',
        'ฉีดวัคซีนป้องกันโรคประจำปี ป้องกันเห็บหมัด พยาธิหนอนหัวใจ ต่อเนื่อง',
        'ไม่เคยได้รับการถ่ายเลือดมาก่อน',
        'นิสัยดี เจ้าของควบคุมได้ และ ใจบุญ'
      ],
      catQualifications: [
        'อายุ 1-7ปี',
        'น้ำหนัก 4kg. ขึ้นไป',
        'สุขภาพแข็งแรง ไม่มีโรคประจำตัว',
        'ฉีดวัคซีนครบถ้วน (หัด-หวัดแมว ลิวคีเมีย พิษสุนัขบ้า ฯลฯ)',
        'ถ่ายพยาธิและป้องกันเห็บ-หมัดเป็นประจำ',
        'นิสัยดี เจ้าของควบคุมได้ และ ใจบุญ'
      ],
      hospitalList: []
    }
  },
  mounted () {
    this.$http.get('hospital/hospital/').then((response) => {
      this.hospitalList = response.data.result.filter(
        hospital => hospital.is_bloodbank_publish
      )
    })
  },
  components: {
    TopBar,
    Container,
    HospitalCard,
    DonationPrepSection,
    DonationStepSection,
    BloodCollectionSection,
    DonationAfterSection,
    DonationThankYouSection
  }
}
</script>

<style scoped lang="scss">
.donation-page {
  padding-top: 2rem;
  padding-bottom: 2rem;
  h2 {
    text-align: center;
    font-weight: $font-weight-light;
    font-size: $h3-font-size;
    margin-bottom: 1rem;
  }
  .subtitle {
    text-align: center;
    font-weight: $font-weight-light;
    font-size: $h6-font-size;
  }
}

.donation-qualification {
  margin-bottom: 1rem;
  .img-container {
    border-right: 1px solid $primary;
    padding-right: 0;
    height: 18rem;
    position: relative;
    img {
      position: absolute;
      right: 0;
      bottom: 0;
      &.dog-img {
        height: 10rem;
      }
      &.cat-img {
        height: 7rem;
      }
    }
  }
  table {
    td {
      padding: 0.125rem 0;
      vertical-align: top;
      img {
        width: 1.5rem;
        margin-right: 1rem;
      }
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .donation-page {
    h2 {
      font-size: $h1-font-size;
    }
    .subtitle {
      font-size: $h5-font-size;
    }
  }

  .donation-qualification {
    margin-bottom: 2rem;
    .img-container {
      img {
        &.dog-img {
          height: 14rem;
        }
        &.cat-img {
          height: 10rem;
        }
      }
    }
    table {
      td {
        padding: 0.25rem 0;
      }
    }
  }
}
</style>
